import React from 'react'
import GoogleMapReact from 'google-map-react'
import MapMaker from './MapMaker'
import { Mapkey } from './mapkey'

const RestaurantMap = ({ restaurantsArray, setSelectedRestaurant }) => {
  const coord = { lat: 18.4803326, lng: -77.9123361 }
  const apiHasLoaded = (map, maps) => {}

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: Mapkey }}
        defaultCenter={coord}
        center={coord}
        defaultZoom={13}
        margin={[50, 50, 50, 50]}
        options={{ disableDefaultUI: true, zoomControl: true, styles: {} }}
        onChange={() => {}}
        onChildClick={() => {}}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => apiHasLoaded(map, maps)}
      >
        {restaurantsArray.map((restaurant, i) => (
          <MapMaker
            key={i}
            rname={restaurant.restaurant.rname}
            image={restaurant.restaurant.image}
            lat={restaurant.restaurant.latitude}
            lng={restaurant.restaurant.longitude}
            onClick={() => setSelectedRestaurant(restaurant)}
          />
        ))}
      </GoogleMapReact>
    </div>
  )
}
export default RestaurantMap
